import React from 'react';
import classNames from 'classnames';

import ToolbarPopup from '../../toolbarPopup/ToolbarPopup';
import TagsPopupContent from '../../../../../element/tags/TagsPopupContent';
import TagEditPopup from '../../../../../element/tags/TagEditPopup';

import { TooltipAlignment } from '../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { Tag } from '../../../../../../common/tags/tagTypes';

import './TagsToolbarPopup.scss';

export type TagsToolbarPopupProps = {
    name: string;
    buttonSelector: string;
    alignment: TooltipAlignment;
    currentUserId: string;
    currentBoardId: string;
    selectedElements: Immutable.List<ImMNElement>;
    tag: Tag | null;
    showEditingPopup: boolean;
    rootPath: Array<ImMNElement>;
    handleClickEdit: (tagId: string) => void;
    closePopup: () => void;
};

const TagsToolbarPopup: React.FC<TagsToolbarPopupProps> = (props) => {
    const { buttonSelector, showEditingPopup } = props;

    return (
        <ToolbarPopup
            buttonSelector={buttonSelector}
            alignment={TooltipAlignment.CENTER}
            popupId={PopupIds.TAGS_TOOL}
            className={classNames('TagsPopup')}
            showArrow={false}
        >
            <TagsPopupContent {...props} />
            {showEditingPopup && <TagEditPopup {...props} />}
        </ToolbarPopup>
    );
};

export default TagsToolbarPopup;
